import settings from "@settings";

export const h1 = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 500,   
    letterSpacing: '2px', 
    fontSize: ['36px','42px', '60px'],
    color: settings.colors.darkgrey,
    margin: 0,
    lineHeight: 1.2,
    maxWidth: '720px',
    'strong': { fontWeight: 700 }
});

export const h2 = settings.mq({
    fontFamily: 'Coco Sharp',
    fontSize: ['24px','36px', '42px'],
    lineHeight: 1,
    marginBottom: settings.sizes.medium,
    marginTop: 0,
    letterSpacing: '2px',
    fontWeight: 700,
    color: 'inherit',
    textAlign: 'left'
});

export const h3 = settings.mq({
    marginBlockEnd: 0,
    marginBottom: settings.sizes.small,
    fontFamily: 'Coco Sharp',
    fontWeight: 700,    
    textTransform: 'uppercase',	
    fontSize: ['12px', '12px','12px'],
    letterSpacing: '1.8px',
    maxWidth: '480px',
    lineHeight: 1.2
});

export const h4 = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 600,    
    fontSize: settings.fontSize.medium,
    letterSpacing: '2px',
    maxWidth: '660px',
    lineHeight: 1.5,
    margin: 0,
    marginTop: settings.sizes.large,
    marginBottom: settings.sizes.small
});

export const h5 = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 300,    
    fontSize: settings.fontSize.large,
    letterSpacing: '1.2px',
    maxWidth: '480px',
    lineHeight: 1.5,
    margin: 0,
    marginBottom: settings.sizes.small
});

export const h6 = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 300,    
    fontSize: settings.fontSize.large,
    letterSpacing: '1.2px',
    maxWidth: '660px',
    lineHeight: 1.5,
    margin: 0,
    marginBottom: settings.sizes.small
});

export const p = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 400,
    fontSize: settings.fontSize.semismall,
    letterSpacing: '1px',
    lineHeight: 1.6,
    marginBlockEnd: settings.sizes.medium
});

export const a = settings.mq({
    fontFamily: 'Coco Sharp',
    fontWeight: 400,
    fontSize: settings.fontSize.tiny,
    textDecoration: 'underline',
    color: settings.colors.darkgrey,
    marginBlockEnd: settings.sizes.medium
});